module.exports = __webpack_public_path__ + "static/media/liquor_germany.3a22c477.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/liquor_germany.jpg
// module id = 418
// module chunks = 0